import { render, staticRenderFns } from "./CustomersSegmentsFilterCustom.vue?vue&type=template&id=23859022&scoped=true&"
import script from "./CustomersSegmentsFilterCustom.vue?vue&type=script&lang=js&"
export * from "./CustomersSegmentsFilterCustom.vue?vue&type=script&lang=js&"
import style0 from "./CustomersSegmentsFilterCustom.vue?vue&type=style&index=0&id=23859022&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23859022",
  null
  
)

export default component.exports